const TextColorsLightValues = Object.freeze({
    base: '#000000',
    tint1: '#4c4c4c',
    tint2: '#808080',
    tint3: '#999999',
    tooltip: '#ffffff',
});
const TextColorsDarkValues = Object.freeze({
    base: '#ffffff',
    tint1: '#b3b3b3',
    tint2: '#808080',
    tint3: '#666666',
    tooltip: '#000000',
});
const TextColors = Object.freeze({
    base: 'var(--texts-base)',
    tint1: 'var(--texts-tint-1)',
    tint2: 'var(--texts-tint-2)',
    tint3: 'var(--texts-tint-3)',
    tooltip: 'var(--texts-tooltip)',
});

export { TextColors, TextColorsDarkValues, TextColorsLightValues };
